angular.module('cn')
.component('networkTree', {
  template: require('./networktree.html'),
  bindings: {
    model: '<',
    nodeMoved: '&',
    nodeAdded: '&',
    nodeRemoved: '&',
    nodeEdited: '&',
    onAdHocAction: '&',
    onError: '&',
    level: '<', // internal
    nodeSelected: '&', // unused
    nodeExpanded: '&', // unused
    nodeCollapsed: '&' // unused
  },
  controller: [
    function() {
      var $ctrl = this;

      $ctrl.$onInit = function() {
        $ctrl.rand = parseInt(Math.random() * 1000);
        $ctrl.level = $ctrl.level || 0;
        $ctrl.isGray = !$ctrl.isFirstRowGray;
      };

      $ctrl.$onChanges = function(changes) {
        if (changes.model && changes.model.currentValue) {
          $ctrl.items = $ctrl.model.getTree();
          $ctrl.items.forEach(function(item) {
            item.collapsed = false;
          });
        }
      };

      $ctrl.expandNode = function(node) {
        node.collapsed = false;
        $ctrl.nodeExpanded({node: node});
      };

      $ctrl.collapseNode = function(node) {
        node.collapsed = true;
        $ctrl.nodeCollapsed({node: node});
      };

      $ctrl.selectNode = function(node) {
        node.collapsed = false;
        $ctrl.nodeSelected({node: node});
        if (node.isRoot) {
          node.editing = true;
        }
      };

      $ctrl.editNode = function(node, data) {
        if (data) {
          $ctrl.nodeEdited({data: data}).finally(function() {
            node.editing = false;
          });
        } else {
          if (node) {
            node.editing = false;
          }
        }
      };

      $ctrl.addNewChild = function(data) {
        if (!data) {
          delete $ctrl.model.enableNewChild;
        } else {
          delete $ctrl.model.enableNewChild;
          $ctrl.nodeAdded({parent: $ctrl.model, data: data});
        }
      };

      $ctrl.removeChild = function(node) {
        $ctrl.nodeRemoved({node: node});
      };

      var isNewParentACurrentChild = function(newParent, account) {
        if (newParent) {
          if (newParent.id === account.id) {
            return true;
          } else {
            return isNewParentACurrentChild(newParent.parent, account);
          }
        }
        return false;
      };

      $ctrl.dropNode = function(childScope, newParent) {
        if (!isNewParentACurrentChild(newParent, childScope.node)) {
          $ctrl.nodeMoved({
            node: childScope.node,
            oldParent: childScope.node.parent,
            newParent: newParent
          });
        } else {
          $ctrl.onError({message: 'Invalid movement'});
        }
      };

      $ctrl.addOnAction = function(actionName) {
        $ctrl.onAdHocAction({actionName: actionName});
      };

    }
  ]
});



// WEBPACK FOOTER //
// ./src/cn/networktree.js